import { Link } from "react-router-dom";
import styled, { FlattenSimpleInterpolation, css } from "styled-components";
import { GlowLink } from "../GlowLink";
import SwipeableViews from "react-swipeable-views";

export const HomeWrapper = styled.div`
	background-color: #fff; ;
`;
export const HomeIntroWrapper = styled.div`
	width: 100%;
	top: 0;
	z-index: 1000;
	background-color: #fff;
	position: fixed;
	border-bottom: 1px solid hsla(0, 0%, 100%, 0.12);
	height: 92px;
	@media screen and (max-width: 768px) {
		margin: 0;
		height: 60px;
	}
`;
export const HomeIntroInner = styled.div<{ none?: boolean }>`
    width: 1200px;
    position: relative;
    margin: 24px auto;
    max-width: 1440px;
    display: flex;
    font-size:16px;
    justify-content: space-between;
	
    @media screen and (max-width: 768px) {
		margin: 0;
    width: 100%;
    padding: 16px;
    height: inherit;
	    align-items: center;
   display: ${({ none }) => (none ? "none" : "flex")};
   border-bottom: 1px solid #E5E7EB;
}
	}
@media screen and (max-width: 768px) {
		padding: 8px 16px;
	}
`;
export const HomeIntroMenuBarLeft = styled.div`
	margin: auto 0;
	@media screen and (max-width: 768px) {
		margin: 0;
		height: 44px;
	}
`;
export const HomeRouterLinkActive = styled(Link)`
	text-decoration: none;
`;
export const HomeRouterLinkActiveImg = styled.img`
	height: 48px;
	@media screen and (max-width: 768px) {
		height: 44px;
	}
`;
export const HomeIntroMenuBarRight = styled.div`
	display: flex;
	align-items: center;
	@media screen and (max-width: 768px) {
	}
`;
export const HomeIntroMenuBarRouteA = styled(GlowLink)`
	text-decoration: none;
	opacity: 1;
	transition: opacity 0.2s;

	&:hover {
		opacity: 0.3;
	}
	border-radius: 8px;
	padding: 12px 16px;
	border: 1px solid #e5e7eb;
	margin-right: 16px;
	height: 44px;
`;
export const HomeIntroMenuBarRouteLogin = styled.div`
	cursor: pointer;
	text-decoration: none;
	opacity: 1;
	transition: opacity 0.2s;

	&:hover {
		opacity: 0.3;
	}
	border-radius: 8px;
	padding: 12px 16px;
	border: 1px solid #e5e7eb;
	// margin-right: 16px;
	height: 44px;
`;
export const HomeIntroMenuBarRoute = styled.div`
	color: #111827;
	font-size: 14px;
	line-height: 20px;
`;
export const LanguageButtonWrap = styled.div`
	background-color: rgba(255, 255, 255, 0.15);
	border-radius: 4px;
	@media screen and (max-width: 768px) {
		margin-right: 12px;
	}
`;
export const LanguageButton = styled.button<{
	isSelected?: boolean;
}>`
	background-color: ${(props) => (props.isSelected ? "white" : "transparent")};
	border: none;
	height: 100%;
	border-radius: 4px;
`;

export const LanguageImgV2 = styled.img`
	margin: 4px 8px;
	height: 16px;
`;
export const SelectLanguage = styled.div`
	position: relative;
	display: inline-block;
	cursor: pointer;
	user-select: none;
`;
export const SelectLanguageNameWeb = styled.div`
	display: inline;
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
export const SelectLanguageNameRes = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		display: inline;
	}
`;
export const DropdownButton = styled.div`
	background: transparent;
	border: none;
	border-radius: 8px;
	outline: none;
	cursor: pointer;
	// padding: 0 10px;
	background: url("dropdown-arrow.png") no-repeat right 10px center;
	display: flex;
	align-items: center;
`;

export const LanguageImg = styled.img`
	margin-right: 12px;
	width: 20px;
	height: 20px;
	border-radius: 100px;
	border: 1px solid #fffd;
`;

export const OptionsList = styled.ul`
	position: absolute;
	right: 0;
	top: 50px;
	list-style: none;
	background-color: rgba(252, 253, 252, 0.8);
	box-shadow: 0 4px 16px 0 rgba(8, 13, 8, 0.16);
	border-radius: 12px;
	padding: 0;
	display: none;

	${SelectLanguage}:hover & {
		display: block;
		width: 150px;
	}
		@media screen and (max-width: 768px) {
		right: -16px;
    background-color: #fff;
    top: 36px;
}
	}
`;

export const OptionLi = styled.li`
  cursor: pointer;
  padding: 12px 8px;
  display: flex;
    align-items: center;
}
  &:hover {
    background-color: #ccc;
    
    border-radius: 12px;
  }
`;

export const HomeIntroMenuBorderLang = styled.div`
	border-radius: 8px;
	padding: 12px 16px;
	border: 1px solid #e5e7eb;
	height: 44px;
	@media screen and (max-width: 768px) {
		// display: none;
	}
`;
export const SearchHomePageWrap = styled.div``;
export const SearchHomePageChild = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 100px 0 185px 0;
	background-image: url(./static/img/Banner.jpg);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center;
	width: 100%;
	height: 100%;
	@media screen and (max-width: 768px) {
		padding: 80px 16px 92px;
		background-size: 250% 100%;
	}
`;
export const SearchHomePageTitle = styled.div`
	font-size: 40px;
	font-weight: 600;
	line-height: 52px;
	text-align: center;
	margin-bottom: 16px;
	color: #fff;
	@media screen and (max-width: 768px) {
		font-size: 24px;
		margin-bottom: 12px;
		line-height: normal;
		font-weight: 500;
	}
`;
export const SearchHomePageNote = styled.div`
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	text-align: center;
	margin-bottom: 60px;
	color: #fff;
	@media screen and (max-width: 768px) {
		font-size: 14px;
		line-height: 24px;
		margin-bottom: 36px;
	}
`;

export const InputSearchWrap = styled.div`
	width: 960px;
	border-radius: 12px;
	padding: 12px 16px 12px 32px;
	display: flex;
	flex-direction: row;
	background: #ffffff;
	justify-content: space-between;
	margin-bottom: 8px;
	position: relative;
	@media screen and (max-width: 768px) {
		width: 100%;
		font-size: 14px;
		line-height: 24px;
		margin-bottom: 16px;
		flex-direction: column;
		padding: 12px 16px 12px 16px;
	}
`;
export const InputSearchWrapMenu = styled(InputSearchWrap)<{ location?: boolean }>`
	// width: 755px;
	width: ${(location) => (location ? "max-content" : "755px")};
	padding: 6px 4px;
	margin-bottom: 0;
	border: 1px solid #e5e7eb;
	@media screen and (max-width: 768px) {
	}
`;
export const InputSearchWrapMenuMap = styled.div`
	@media screen and (max-width: 768px) {
		width: 100%;
		padding: 6px 4px 6px 16px;
		display: flex;
		align-items: center;
		border-radius: 12px;
		border: 1px solid #e5e7eb;
		background: #fff;
		justify-content: space-between;
		height: 44px;
	}
`;
export const MenuSearchMapWrap = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		width: 100%;
		padding: 8px 16px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid rgb(229, 231, 235);
	}
`;
export const MenuSearchMapHome = styled(Link)`
	@media screen and (max-width: 768px) {
		display: flex;
		width: 24px;
		height: 24px;
		padding: 6px 0px;
		justify-content: center;
		align-items: center;
		margin-right: 16px;
		text-decoration: none;
	}
`;
export const MenuSearchMapHomeImg = styled.img`
	width: 24px;
	height: 24px;
	@media screen and (max-width: 768px) {
	}
`;
export const InputSearchWhere = styled.div`
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	@media screen and (max-width: 768px) {
		font-weight: 500;
	}
`;

export const InputSearchWhereLeft = styled.div`
	@media screen and (max-width: 768px) {
		margin-bottom: 12px;
		width: 100%;
	}
`;
export const InputSearchWhereLeftMenu = styled.div`
	display: flex;
	padding: 6px 16px;
	@media screen and (max-width: 768px) {
		margin-bottom: 12px;
	}
`;
export const InputSearchWhereLeftMenuMap = styled.div`
	display: flex;
	width: 100%;
	// padding: 6px 16px;
	@media screen and (max-width: 768px) {
		// margin-bottom: 12px;
	}
`;
export const InputSearchWhereRight = styled.div`
	display: flex;
	flex-direction: row;
	padding-left: 16px;
	border-left: 1px solid #e5e7eb;
	@media screen and (max-width: 768px) {
		padding-left: 0;
		border-left: none;
		justify-content: center;
	}
`;

export const InputSearchWhereRightMenu = styled(InputSearchWhereRight)`
	border-left: 0px solid #e5e7eb;
	@media screen and (max-width: 768px) {
	}
`;
export const InputSearchWhereRightMenuMap = styled(InputSearchWhereRight)`
	border-left: 0px solid #e5e7eb;
	@media screen and (max-width: 768px) {
	}
`;
export const InputSearchMain = styled.input`
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	// color: #6B7280;
	width: 600px;
	border: none;
	outline: none;
	font-family: inherit;

	&:focus {
		outline: none;
	}
	@supports (-webkit-overflow-scrolling: touch) {
		& {
			font-size: 16px;
		}
	}

	@media screen and (max-width: 768px) {
		width: 100%;
	}
`;
export const ClearButton = styled.div<{ mobile?: boolean }>`
	font-size: 16px;
	font-weight: 600;
	color: rgb(209, 213, 219);
	cursor: pointer;
	margin-right: ${({ mobile }) => (mobile ? "10px" : "0")};
	margin-left: 10px;
	&:hover {
		color: #052d2f;
	}
`;
export const InputSearchClearWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between; ;
`;
export const InputSearchMainMenu = styled(InputSearchMain)`
	width: 300px;
`;
export const InputSearchMainMenuMap = styled(InputSearchMain)`
	width: 100%;
`;
export const InputSearchButton = styled.div`
	border-radius: 8px;
	padding: 12px 16px;
	border: 1px solid #e5e7eb;
	height: 48px;
	margin-right: 16px;
	display: flex;
	align-items: center;
	cursor: pointer;
	@media screen and (max-width: 768px) {
		width: 50%;
		max-width: 200px;
		justify-content: center;
	}
`;
export const InputSearchButtonMenu = styled(InputSearchButton)`
	height: 36px;
	border: 1px solid #9bb7f0;
	@media screen and (max-width: 768px) {
	}
`;
export const InputSearchButtonMenuMap = styled(InputSearchButton)`
	@media screen and (max-width: 768px) {
		display: flex;
		height: 36px;
		width: 36px;
		padding: 12px 8px;
		justify-content: center;
		align-items: center;
		margin-right: 8px;
	}
`;
export const InputSearchNear = styled.div<{ disabled?: boolean }>`
	cursor: pointer;
	border-radius: 8px;
	padding: 12px 16px;
	border: 1px solid #e5e7eb;
	height: 48px;
	// background: #035d9d;
	color: #fff;
	display: flex;
	align-items: center;
	pointer-events: ${({ disabled }) => (disabled ? "none" : "")};
	background-color: ${({ disabled }) => (disabled ? "#596873" : "#035d9d")};
	@media screen and (max-width: 768px) {
		width: 50%;
		max-width: 200px;
		justify-content: center;
	}
`;
export const InputSearchNearMenu = styled(InputSearchNear)`
	height: 36px;
	@media screen and (max-width: 768px) {
	}
`;
export const InputSearchNearMenuMap = styled(InputSearchNear)`
	@media screen and (max-width: 768px) {
		display: flex;
		height: 36px;
		width: 36px;
		padding: 12px 8px;
		justify-content: center;
		align-items: center;
		border: none;
	}
`;

export const InputSearchButtonIcon = styled.img`
	display: flex;
	width: 20px;
	height: 20px;
	justify-content: center;
	align-items: center;
	margin-right: 8px;
`;
export const InputSearchButtonIconMap = styled(InputSearchButtonIcon)`
	margin-right: 0px;
`;

export const UserManualWrap = styled.div`
	width: 100%;
	padding: 88px 0px;
	@media screen and (max-width: 768px) {
		padding: 20px 16px 60px 16px;
	}
`;
export const DetailLocationManualWrap = styled.div`
	width: 100%;
	padding: 88px 0px;
	@media screen and (max-width: 768px) {
		padding: 60px 16px 60px 16px;
	}
`;

export const UserManualInner = styled.div`
	width: 1200px;
	margin: 24px auto;
	max-width: 1440px;
	display: flex;
	justify-content: space-between;
	@media screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;

export const RecommendLocationPageWrap = styled.div`
	width: 960px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	@media screen and (max-width: 768px) {
		width: 100%;
		overflow-x: auto;
		white-space: nowrap;
		line-height: 20px;
		scrollbar-width: none;
		justify-content: start;
		&::-webkit-scrollbar {
			display: none;
		}
	}
`;

export const RecommendLocationPageInner = styled(Link)`
display: flex;
padding: 6px 12px;
justify-content: center;
align-items: center;
border-radius: 31px;
background: rgba(255, 255, 255, 0.12);
backdrop-filter: blur(8px);
margin 0 2px;
color: #fff;
cursor: pointer;
    text-decoration: none;
`;
export const UserManualItem = styled.div`
	width: calc(25% - 24px);
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	@media screen and (max-width: 768px) {
		width: 100%;
		flex-direction: row;
		margin-bottom: 32px;
	}
`;
export const UserManualItemImgWrap = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: 24px;
	@media screen and (max-width: 768px) {
		margin-bottom: 0px;
		margin-right: 24px;
	}
`;
export const UserManualItemImg = styled.img`
	width: 72px;
	height: 72px;
`;
export const UserManualItemContent = styled.div``;
export const UserManualItemStep1 = styled.div`
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 18px;
	color: #6b7280;
	@media screen and (max-width: 768px) {
		font-size: 12px;
		font-style: normal;
		font-weight: 500;
		line-height: 18px;
	}
`;
export const UserManualItemStep2 = styled.div`
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 28px;
	color: #111827;
	@media screen and (max-width: 768px) {
		font-size: 18px;
		font-style: normal;
		font-weight: 500;
		line-height: 28px;
	}
`;
export const UserManualItemStep3 = styled.div`
	color: #1a1a1a;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	@media screen and (max-width: 768px) {
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 20px;
	}
`;
export const UserManualTitle = styled.div`
	color: #111827;
	text-align: center;
	font-size: 36px;
	font-weight: 600;
	line-height: 36px;
	margin-bottom: 72px;
	@media screen and (max-width: 768px) {
		font-size: 20px;
		font-weight: 500;
		line-height: 28px;
		margin-bottom: 44px;
	}
`;

export const IntroduceEnsureWrap = styled.div`
	width: 100%;
	background: rgba(3, 93, 157, 0.08);
	padding: 63px 0;
	@media screen and (max-width: 768px) {
		padding: 44px 16px;
	}
`;
export const IntroduceEnsureChild = styled.div`
	width: 1200px;
	margin: auto;
	max-width: 1440px;
	display: flex;
	justify-content: space-between;

	@media screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;

export const IntroduceEnsureTitle = styled.div`
	color: #111827;
	text-align: center;
	font-size: 28px;
	font-style: normal;
	font-weight: 600;
	line-height: 36px;
	margin-bottom: 64px;
	@media screen and (max-width: 768px) {
		margin-bottom: 32px;
		font-size: 20px;
		font-weight: 500;
		line-height: 32px;
	}
`;
export const IntroduceEnsureChildLeft = styled.div`
	height: 410px;
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
export const IntroduceEnsureChildLeftImg = styled.img`
	width: 100%;
`;
export const IntroduceEnsureChildRight = styled.div`
	width: 630px;
	display: flex;
	flex-wrap: wrap;
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
export const IntroduceEnsureChildRightRes = styled(SwipeableViews)`
	display: none;
	@media screen and (max-width: 768px) {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 32px;
	}
`;
export const IntroduceEnsureChildRightInner = styled.div`
	width: 50%;
	padding-left: 36px;

	@media screen and (max-width: 768px) {
		width: 100%;
		padding-left: 0px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`;
export const IntroduceEnsureChildRightInnerImgWrap = styled.div`
	margin-bottom: 18px;
	@media screen and (max-width: 768px) {
		margin-bottom: 20px;
	}
`;
export const IntroduceEnsureChildRightInnerImg = styled.img`
	width: 64px;
	height: 64px;
	object-fit: cover;
`;
export const IntroduceEnsureChildRightInnerContentWrap = styled.div`
	@media screen and (max-width: 768px) {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`;
export const IntroduceEnsureChildRightInnerContent1 = styled.div`
	color: #111827;
	font-size: 24px;
	font-weight: 600;
	line-height: 32px;
	margin-bottom: 5px;
`;
export const IntroduceEnsureChildRightInnerContent2 = styled.div`
	color: #111827;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
`;
export const TopDestinationsWrap = styled.div`
	width: 100%;
	padding: 88px 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	@media screen and (max-width: 768px) {
		padding: 44px 16px;
		align-items: flex-start;
	}
`;
export const TopDestinationsTitle = styled.div`
	color: #111827;
	text-align: center;
	font-size: 28px;
	font-weight: 600;
	line-height: 36px;
	margin-bottom: 48px;
	@media screen and (max-width: 768px) {
		font-size: 28px;
		font-style: normal;
		font-weight: 500;
		line-height: 36px;
	}
`;
export const TopDestinationsInnerWrap = styled.div`
	width: 1200px;
	max-width: 1200px;
	margin: auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
export const TopDestinationsInnerWrapRes = styled(SwipeableViews)`
	display: none;
	@media screen and (max-width: 768px) {
		width: 335px;
		display: flex;

		margin-bottom: 32px;
		flex-direction: column;
		overflow-x: visible !important;
	}
`;
export const TopDestinationsInnerWrapResNoSSR = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		width: 100%;
		display: flex;
		margin-bottom: 32px;
		overflow-x: auto;
		scrollbar-width: none;
		-ms-overflow-style: none;

		&::-webkit-scrollbar {
			display: none;
		}
	}
`;
export const TopDestinationsInnerWrapResWrap = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		overflow-x: hidden;
		display: flex;
		width: 100%;
	}
`;
export const TopDestinationsInner = styled(Link)`
	width: calc(100% / 3 - 16px);
	border-radius: 12px;
	background: #fff;
	box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);
	margin-bottom: 44px;
	margin-right: 24px;

	&:nth-child(3n) {
		margin-right: 0;
	}
	text-decoration: none;
	@media screen and (max-width: 768px) {
		width: 311px;
		margin-bottom: 4px;

		&:nth-child(3n) {
			margin-right: 24px;
		}
	}
`;
export const TopDestinationsInnerImgWrap = styled.div``;
export const TopDestinationsInnerImg = styled.img`
	height: 216px;
	width: 100%;
	object-fit: cover;
	border-radius: 12px 12px 0 0;
	@media screen and (max-width: 768px) {
		width: 311px;
		height: 175px;
	}
`;
export const TopDestinationsInnerContentWrap = styled.div`
	padding: 16px;
	@media screen and (max-width: 768px) {
		padding: 8px 16px;
	}
`;
export const TopDestinationsInnerName = styled.div`
	color: #111827;
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 28px;
	@media screen and (max-width: 768px) {
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
		margin-bottom: 5px;
	}
`;
export const TopDestinationsInnerContent = styled.div`
	color: #6b7280;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	@media screen and (max-width: 768px) {
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
	}
`;

export const TopDestinationsSeeAll = styled(Link)`
	color: #1250dc;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px;
	margin-bottom: 44px;
	cursor: pointer;
	text-decoration: none;
	@media screen and (max-width: 768px) {
		// display: none;
		margin: 0px auto;
	}
`;

export const OurPartnersWrap = styled.div`
	width: 1200px;
	max-width: 1200px;
	padding: 88px 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: auto;
	@media screen and (max-width: 768px) {
		padding: 44px 16px;
		width: 100%;
	}
`;
export const OurPartnersTitle = styled.div`
	color: #111827;
	text-align: center;
	font-size: 28px;
	font-weight: 600;
	line-height: 36px;
	margin-bottom: 32px;
	@media screen and (max-width: 768px) {
		margin-bottom: 48px;
		font-size: 20px;
		font-weight: 600;
		line-height: 32px;
	}
`;
export const OurPartnersInnerWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
export const OurPartnersInnerWrapRes = styled(SwipeableViews)`
	display: none;
	@media screen and (max-width: 768px) {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 48px;
	}
`;
export const OurPartnersInnerImgWrap = styled.div`
	display: flex;
	width: 285px;
	height: 150px;
	max-width: 285px;
	padding: 0px 15px;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	@media screen and (max-width: 768px) {
		width: 100%;
		padding-left: 0px;
		display: flex;
		flex-direction: column;
		align-items: center;
		max-width: 100%;
		height: 100%;
	}
`;
export const OurPartnersInnerImg = styled.img``;
export const OurPartnersSeeAll = styled.div`
	color: #1250dc;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
export const DotsWrapper = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		display: flex;
		justify-content: center;
	}
`;

export const Dot = styled.div<{ active: boolean }>`
	width: 8px;
	height: 8px;
	margin: 0 2px;
	border-radius: 50%;
	background-color: ${(props) => (props.active ? "#035D9D" : "#035D9D")};
	opacity: ${(props) => (props.active ? "1" : "0.3")};
	transition: background-color 0.3s;
`;

export const HomeMenuLoginWrapWrap = styled.div`
	position: relative;
	z-index: 1001;
	cursor: pointer;
	text-decoration: none;
	opacity: 1;
	transition: opacity 0.2s;

	border-radius: 8px;
	padding: 12px 16px;
	border: 1px solid #e5e7eb;
	margin-right: 16px;
	height: 44px;
	display: flex;
	@media screen and (max-width: 768px) {
		display: flex;
		padding: 12px;
	}
`;
export const HomeMenuLoginWrap = styled.div`
	display: flex;
	align-items: center;
	// color: #fff;
`;
export const HomeLoginAvatar = styled.img`
	height: 32px;
	width: 32px;
	border: 1px solid #fff;
	border-radius: 100px;
	margin-right: 8px;
`;
export const HomeMenuLoginName = styled.div`
	margin-right: 4px;
`;

export const HomeMenuLoginSelect = styled.div`
	position: absolute;
	right: 0;
	z-index: 1002;
	background-color: #fff;
	border-radius: 12px;
	top: 60px;
	box-shadow: 0px 4px 15.3px 0px #11182729;
	max-height: calc(100vh - 80px);
	overflow-y: auto;
	min-width: 220px;
	@media screen and (max-width: 768px) {
		top: 50px;
	}
`;
export const HomeMenuSectionLabel = styled.div`
	padding: 8px 14px 2px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	color: #9ca3af;
	&:not(:first-child) {
		border-top: 1px solid #f0f0f0;
		margin-top: 4px;
	}
`;
export const HomeMenuIcon = styled.i`
	width: 18px;
	font-size: 14px;
	text-align: center;
	color: #6b7280;
	margin-right: 8px;
	flex-shrink: 0;
`;
export const HomeMenuLoginOption = styled.div`
	padding: 8px 14px;
	background-color: #fff;
	border: none;
	border-radius: 8px;
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: background-color 0.15s;
	&:hover {
		background-color: #f3f4f6;
	}
`;
export const HomeMenuLoginOptionLogOut = styled(HomeMenuLoginOption)`
	border-radius: 0 0 8px 8px;
	border-top: 1px solid #e5e7eb;
`;
export const HomeMenuLoginOptionImg = styled.img`
	width: 20px;
	height: 20px;
`;
export const HomeMenuLoginOptionLink = styled(Link)`
	text-decoration: none;
	color: var(--text-color0);
	display: block;
`;
export const HomeMenuLoginOptionInner = styled.div`
	flex: 1;
	color: var(--text-color0);
	white-space: nowrap;
	font-size: 14px;
	line-height: 20px;
`;

export const InputSearchAnswer = styled.div`
	position: absolute;
	top: 72px;
	left: 12px;
	padding: 12px;
	background-color: #fff;
	border-radius: 12px;
	box-shadow: 0px 4px 15.3px 0px #11182729;
	z-index: 1;
	max-width: 930px;
	width: calc(100% + 24px);
	@media screen and (max-width: 768px) {
		left: -12px;
	}
`;

export const InputSearchAnswerInner = styled.div`
	padding: 4px 12px;
	border-radius: 8px;
	line-height: 24px;
	cursor: pointer;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	&:hover {
		background-color: #ddd;
	}
`;
export const LocationInputSearchMenuWrap = styled.div``;
